module.exports = __webpack_public_path__ + "img/fire_tool_5.819d8b2a.png";